// extracted by mini-css-extract-plugin
export default {"wrapper":"LatestReleases_wrapper__9XHbR","header":"LatestReleases_header__VC2JG","content":"LatestReleases_content__W3zEz"};